/* eslint-disable no-console */
export function enableB2CNetworkDebugging(): void {
    const originalFetch = window.fetch;

    window.fetch = async (...args): Promise<Response> => {
        const [url, options] = args;
        const urlString = typeof url === 'string' ? url : url.toString();

        // Only intercept B2C token requests
        if (urlString.includes('b2clogin.com') && urlString.includes('/token')) {
            console.group('🔍 B2C Token Request');
            console.log('URL:', urlString);
            console.log('Method:', options?.method || 'GET');
            console.log('Timestamp:', new Date().toISOString());
            console.groupEnd();
        }

        try {
            const response = await originalFetch(...args);

            if (urlString.includes('b2clogin.com') && urlString.includes('/token')) {
                console.group('📥 B2C Token Response');
                console.log('URL:', urlString);
                console.log('Status:', response.status, response.statusText);
                console.log('OK:', response.ok);

                const contentType = response.headers.get('content-type');
                console.log('Content-Type:', contentType);

                const clonedResponse = response.clone();

                try {
                    const text = await clonedResponse.text();

                    if (contentType?.includes('application/json')) {
                        try {
                            const json = JSON.parse(text);
                            console.log('✅ Response (JSON):', json);
                        } catch {
                            console.error('❌ Failed to parse JSON:', text);
                        }
                    } else {
                        console.error('❌ Azure B2C returned HTML instead of JSON');

                        // Extract full error details
                        const correlationMatch = text.match(/CorrelationId['":\s]+([a-f0-9-]+)/i);
                        const errorCodeMatch = text.match(/AADB2C[0-9]+/i);
                        const detailMatch = text.match(/"Detail":\s*"([^"]+)"/i);
                        const errorDescMatch = text.match(/"error_description":\s*"([^"]+)"/i);

                        console.error('🔍 Full HTML Response (first 2000 chars):', text.substring(0, 2000));

                        if (correlationMatch) {
                            console.error('🆔 Correlation ID:', correlationMatch[1]);
                        }
                        if (errorCodeMatch) {
                            console.error('⚠️ Error Code:', errorCodeMatch[0]);
                        }
                        if (detailMatch) {
                            console.error('📝 Error Detail:', detailMatch[1]);
                        }
                        if (errorDescMatch) {
                            console.error('📝 Error Description:', errorDescMatch[1]);
                        }

                        console.error('💡 Action Required:');
                        console.error('   1. Copy the Correlation ID above');
                        console.error('   2. Check Azure B2C Application Insights logs');
                        console.error('   3. Look for policy configuration issues');
                    }
                } catch (e) {
                    console.error('❌ Could not read response body:', e);
                }

                console.log('Timestamp:', new Date().toISOString());
                console.groupEnd();
            }

            return response;
        } catch (error) {
            if (urlString.includes('b2clogin.com') && urlString.includes('/token')) {
                console.group('❌ B2C Token Request Failed');
                console.error('URL:', urlString);
                console.error('Error:', error);
                console.groupEnd();
            }
            throw error;
        }
    };

    console.log('🔧 B2C Network Debugger enabled - Enhanced error extraction');
}
